// extracted by mini-css-extract-plugin
export default {"wrapper":"uxyIke3GEIx49pEuwy0b","currencySelectWrapper":"pR09_jY6Rm7YevRofQ5i","periodsNavigationWrapper":"sd5yXidAusi5dYnHwIyu"};